<template>
  <el-table v-loading="loading" :data="data">
    <el-table-column label="STT" type="index" width="50" align="center"></el-table-column>
    <el-table-column label="Nguồn" width="130" align="center">
      <template slot-scope="scope">
        <el-tag :type="getOriginTagType(scope.row.origin)" size="small">
          <i :class="getOriginIcon(scope.row.origin)" class="mr-1"></i>
          {{ getOriginLabel(scope.row.origin) }}
        </el-tag>
      </template>
    </el-table-column>

    <el-table-column label="Địa điểm (Place ID)" min-width="160" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{ scope.row.place_id || '-' }}</span>
      </template>
    </el-table-column>

    <!-- <el-table-column label="Tác giả" min-width="180">
      <template slot-scope="scope">
        <div class="author-info">
          <el-avatar :size="32" :src="scope.row.author_avatar_url || defaultAvatar" class="mr-2">
            {{ scope.row.author_name ? scope.row.author_name.charAt(0) : 'A' }}
          </el-avatar>
          <span class="font-weight-bold">{{ scope.row.author_name || 'N/A' }}</span>
        </div>
      </template>
    </el-table-column> -->

    <el-table-column label="Đánh giá" width="160" align="center">
      <template slot-scope="scope">
        <el-rate
          v-if="scope.row.origin === 'google' || scope.row.origin === 'gg'"
          v-model="scope.row.rating"
          disabled
          allow-half
          show-score
          text-color="#ff9900"
          score-template="{value}"
        ></el-rate>
        <span v-else class="font-weight-bold text-primary">{{ scope.row.rating }} / 10</span>
      </template>
    </el-table-column>

    <el-table-column label="Thông tin khác" width="140" align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.extra_data && scope.row.extra_data.helpful_votes !== undefined">
          👍 {{ scope.row.extra_data.helpful_votes }} bình chọn
        </span>
        <span v-else>-</span>
      </template>
    </el-table-column>

    <el-table-column label="Link gốc" min-width="160" show-overflow-tooltip>
      <template slot-scope="scope">
        <a v-if="scope.row.source_url" :href="scope.row.source_url" target="_blank" class="source-link">
          <i class="fas fa-external-link-alt mr-1"></i> {{ scope.row.source_url }}
        </a>
        <span v-else>-</span>
      </template>
    </el-table-column>

    <el-table-column label="Ngày đánh giá" width="130" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.rated_at || '-' }}</span>
      </template>
    </el-table-column>

    <el-table-column label="Thao tác" width="100" align="center" fixed="right">
      <template slot-scope="scope">
        <el-tooltip content="Chỉnh sửa" placement="top">
          <el-button icon="el-icon-edit" type="primary" circle size="small" @click="handleUpdateRating(scope.row)"></el-button>
        </el-tooltip>
        <el-tooltip content="Xóa" placement="top">
          <el-button icon="el-icon-delete" type="danger" circle size="small" @click="handleDeleteRating(scope.row)"></el-button>
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { deletePlaceRating } from '@/services/place-rating'

export default {
  name: 'ListPlaceRating',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: Boolean
  },
  data() {
    return {
      defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
    }
  },
  computed: {
    ...mapGetters(['constant']),
    locales() {
      return (this.constant && this.constant.constants && this.constant.constants.locales) || []
    }
  },
  methods: {
    handleDeleteRating(row) {
      this.$confirm('Bạn có chắc chắn muốn xóa đánh giá này không?', 'Cảnh báo', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        const params = {
          id: row.id
        }
        deletePlaceRating(params).then(() => {
          this.$notify.success({
            title: 'Thành công',
            message: 'Xóa đánh giá thành công'
          })
          this.$emit('reload')
        }).catch((err) => {
          this.$notify.error({
            title: 'Lỗi',
            message: (err && err.response && err.response.data && err.response.data.message) || 'Xóa đánh giá thất bại'
          })
        })
      }).catch(() => {})
    },
    handleUpdateRating(row) {
      this.$emit('update', row)
    },
    getOriginTagType(origin) {
      if (origin === 'google') return 'primary'
      if (origin === 'booking') return 'success'
      if (origin === 'council') return 'warning'
      return 'info'
    },
    getOriginIcon(origin) {
      if (origin === 'google') return 'fab fa-google'
      if (origin === 'booking') return 'fas fa-hotel'
      if (origin === 'council') return 'fas fa-award'
      return 'fas fa-star'
    },
    getOriginLabel(origin) {
      if (origin === 'google') return 'Google'
      if (origin === 'booking') return 'Booking'
      if (origin === 'council') return 'Hội đồng'
      return origin || 'N/A'
    }
  }
}
</script>

<style lang="scss" scoped>
.author-info {
  display: flex;
  align-items: center;
}

.source-link {
  color: #409EFF;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}

img.language {
  width: 24px;
  height: 24px;
  border-radius: 0px;
  margin: 0 3px;
  &.inactive {
    filter: grayscale(100%);
  }
}
</style>
